import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import blank from "Media/blank-profile-picture.png";
import firebase from "firebase/compat/app";
import moment from "moment-timezone";
import { renderChatProfileAction } from "Redux/action/render.action";
import { seenOnClick } from "Components/Chat/ChatTimer/ChatTimer";
import profilePic from "Media/blank-profile-picture.png";
import ExternalIcon from "Media/icons/External_icon.svg";
const ChatUserSubCard = () => {
  const user_data_list = useSelector(
    (state) => state.renderRecentChatUserReducer
  );
  const my_id = useSelector((state) => state.authenticationReducer?.id);
  const send_by = useSelector((state) => state.authenticationReducer?.id);
  const dispatch = useDispatch();
  const [allMessages, setAllMessages] = useState([]);

  // Deduplicate by user/group so we don't render the same chat multiple times.
  // Prefer id so the same 1:1 user isn't shown twice when list has both id and unique_id entries.
  const uniqueUserList = React.useMemo(() => {
    if (!Array.isArray(user_data_list) || user_data_list.length === 0)
      return [];
    const seen = new Set();
    return user_data_list.filter((curr) => {
      const key = curr?.id ?? curr?.unique_id;
      if (key == null || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }, [user_data_list]);
  const LoadCard = ({ curr, allMessages }) => {
    const message = allMessages;
  
    // keep rest of LoadCard same as before
    // // const [message, setMessage] = useState("");

    // getting message and time from firebase
    useEffect(() => {
      const unsubscribe = firebase
        .firestore()
        .collection("chatroom")
        .orderBy("createdAt", "desc")
        .onSnapshot((querySnap) => {
          const newData = querySnap.docs.map((doc) => {
            const data = doc.data();
            return {
              ...data,
              createdAt: data.createdAt?.toDate() || new Date(),
              docID: doc.id,
            };
          });
    
          setAllMessages((prev) => {
            const prevStr = JSON.stringify(prev);
            const newStr = JSON.stringify(newData);
            return prevStr !== newStr ? newData : prev;
          });
        });
    
      return () => unsubscribe();
    }, []);
    // useEffect(() => {
    //   const messageFunction = async () => {
    //     const messageRef = firebase
    //       .firestore()
    //       .collection("chatroom")
    //       .orderBy("createdAt", "desc");

    //     messageRef.onSnapshot((querySnap) => {
    //       const allData = querySnap.docs?.map((docSanp) => {
    //         const data = docSanp.data();
    //         if (data.createdAt) {
    //           return {
    //             ...docSanp.data(),
    //             createdAt: docSanp.data().createdAt.toDate(),
    //           };
    //         } else {
    //           return {
    //             ...docSanp.data(),
    //             createdAt: new Date(),
    //           };
    //         }
    //       });
    //       setMessage(allData);
    //     });
    //   };

    //   const messageFnReturn = messageFunction();
    // }, []);
    
    const RenderChatList = ({
      message,
      time,
      curr,
      date,
      seen_data,
      docid,
    }) => {
      while (message.includes("&*&")) {
        message = message.replace("&*&", "\n");
      }
      let recent_msg = false;

      // condition for recent msg class
      if (seen_data) {
        // checking if this is empty
        for (let i in seen_data) {
          if (
            Object.values(seen_data[i])?.toString() === "unseen" &&
            Object.keys(seen_data[i])?.toString() === send_by?.toString()
          ) {
            recent_msg = true;
          }
        }
      }

      return (
        <div
          className={
            recent_msg
              ? "chatusercard-container recent-msg"
              : "chatusercard-container"
          }
          onClick={() => {
            // if (curr?.unique_id || false) {
            dispatch(renderChatProfileAction(curr?.unique_id));
            // } else {
            //   dispatch(renderChatProfileAction(curr?.id));
            // }
            // on click we are updating UNSEEN to SEEN
            if (seen_data) {
              const update_seen_data = seenOnClick(seen_data, send_by);
              firebase.firestore().collection("chatroom").doc(docid).update({
                seen_data: update_seen_data,
              });
              console.log({docid,send_by})
                 firebase.firestore()
    .collection('chatroom')
    .doc(docid)
    .collection('seenStatus')
    .doc(String(send_by))//loggedinuserid
    .set({
      lastSeenAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
            }
          }}
        >
          <div>
            <div className="chat-screen-logo">
              {/* Main Profile Image */}
              <img
                src={curr?.image || blank}
                alt="Logo"
                onError={(e) => {
                  e.target.onerror = null; // Prevent infinite loop
                  e.target.src = blank; // Fallback to demo image
                }}
              />

              {/* External Icon (Only if chat_scope is external) */}
              {curr?.chat_scope === "external" && (
                <span className="external-icon">
                  <img
                    src={ExternalIcon || profilePic}
                    alt="External"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = profilePic;
                    }}
                  />
                </span>
              )}

              {/* Status Indicator */}
              <div className="chat-screen-status-dot">
                {!curr?.chat_type &&
                  curr?.chat_type !== "group" &&
                  (curr?.online_status?.toString() === "online" ? (
                    <span className="user-status" style={{ color: "#87c823" }}>
                      <FiberManualRecordIcon />
                    </span>
                  ) : (
                    <span className="user-status" style={{ color: "#c23616" }}>
                      <FiberManualRecordIcon />
                    </span>
                  ))}
              </div>
            </div>
            <div className="chat-screen-profile">
             

              <h5>{curr?.name ? curr?.name : "No Name"}</h5>
              <p>{message ? message : "..."}</p>
            </div>
          </div>
          <div className="chat-screen-time">
            <span>{time ? time : null}</span>
            <span>{date ? date : null}</span>
          </div>
        </div>
      );
    };

    // Deduplicate by conversation: one card per chat (handles multiple Firestore docs per chat)
    const renderedConversationKeys = new Set();
    const getConversationKey = (currEle) => {
      if (currEle?.type?.toString() === "group") return currEle?.docID;
      if (Array.isArray(currEle?.chatID)) {
        return [...currEle.chatID].sort().join("_");
      }
      return currEle?.docID;
    };

    return (
      <>
        {message?.toString() !== ""
          ? message?.map((currEle) => {
              const conversationKey = getConversationKey(currEle);
              if (!conversationKey || renderedConversationKeys.has(conversationKey))
                return null;
              // this logic compares the firebase and backend data then prints the result
              for (let i in currEle.chatID) {
                if (my_id?.toString() === currEle?.chatID[i]?.toString()) {
                  // for one-to-one chat
                  if (currEle?.type?.toString() !== "group") {
                    for (let j in currEle.chatID) {
                      if (my_id !== currEle.chatID[j]) {
                        if (
                          currEle.chatID[j]?.toString() === curr?.id?.toString()
                        ) {
                          renderedConversationKeys.add(conversationKey);
                          var date = moment(currEle?.createdAt)
                            .tz("Europe/Paris")
                            .format();
                          let timeConverted = moment(date).format("hh:mm A");
                          let dateConverted = moment(date).format("MM/DD/YYYY");
                          return (
                            <RenderChatList
                              key={conversationKey}
                              message={currEle?.lastMessage}
                              time={timeConverted}
                              curr={curr}
                              date={dateConverted}
                              seen_data={currEle?.seen_data}
                              docid={currEle?.docID}
                            />
                          );
                        }
                      }
                    }
                  } else if (currEle?.type?.toString() === "group") {
                    // for groups
                    if (
                      curr?.unique_id?.toString() === currEle?.docID?.toString()
                    ) {
                      renderedConversationKeys.add(conversationKey);
                      var date = moment(currEle.createdAt)
                        .tz("Europe/Paris")
                        .format();
                      let timeConverted = moment(date).format("hh:mm A");
                      let dateConverted = moment(date).format("MM/DD/YYYY");
                      return (
                        <RenderChatList
                          key={conversationKey}
                          message={currEle.lastMessage}
                          time={timeConverted}
                          curr={curr}
                          date={dateConverted}
                          seen_data={currEle?.seen_data}
                          docid={currEle?.docID}
                        />
                      );
                    }
                  }
                }
              }
              return null;
            })
          : null}
      </>
    );
  };

  return (
    <>
      {uniqueUserList.length?.toString() !== "0" ? (
        uniqueUserList?.map((curr) => {
          const cardKey = curr?.id ?? curr?.unique_id ?? Math.random();
          return <LoadCard key={cardKey} curr={curr} allMessages={allMessages} />;
        })
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          No Recent Chats
        </div>
      )}
    </>
  );
};

export default ChatUserSubCard;
